export default __webpack_public_path__ + "static/media/science_logo.40696026.svg";